module.exports = __webpack_public_path__ + "static/img/tt-2.2f79b67.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-2.jpg
 ** module id = 589
 ** module chunks = 2
 **/